import React, { useEffect } from "react";
import "./App.css";
import Home from "./Pages/Home/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./Global/GLobal.css";
import Template from "./Pages/Template/Template";
import Plan from "./Pages/Plan/Plan";
import Goal from "./Pages/Goal/Goal";
import PrivacyPolicy from "./Pages/Police/PrivacyPolicy/PrivacyPolicy";
import Terms from "./Pages/Police/Termsandcondition/Terms";
import Faq from "./Pages/Faq/Faq";
import Contact from "./Pages/Contactus/Contact";
import AOS from "aos";
import "aos/dist/aos.css";
import CancelationandRefund from "./Pages/Police/CancelationandRefund/CancelationandRefund";
import LearnMore from "./Pages/Goal/learnMore";
function App() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Template" element={<Template />} />
          <Route path="/Plan" element={<Plan />} />
          <Route path="/Goal" element={<Goal />} />
          <Route path="/LearnMore" element={<LearnMore />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/CancelationandRefund" element={<CancelationandRefund />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Faq" element={<Faq />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
